import { startBgm, stopBgm, stopOtherBgm } from "./bgmPlayers.js";
import type { GameBgmId } from "./bgmTracks.js";

export type { GameBgmId };
export { BGM_MASTER_GAIN } from "./bgmVolume.js";
export { bgmForState } from "./bgmForState.js";

let requestedTrack: GameBgmId | null = null;

export async function syncGameBgm(track: GameBgmId | null): Promise<void> {
  if (track === requestedTrack) {
    if (track) await startBgm(track);
    return;
  }

  requestedTrack = track;
  stopOtherBgm(track);
  if (!track) return;

  const started = await startBgm(track);
  if (started && requestedTrack !== track) stopBgm(track);
}
